import { msg } from '@lingui/core/macro';

export const SHARED_MULTI_SEARCH_SELECT_ALL = msg`Select All`;
export const SHARED_MULTI_SEARCH_SELECT_CLEAR_ALL = msg`Clear All`;
export const SHARED_MULTI_SEARCH_SELECT_CANCEL = msg`Cancel`;
export const SHARED_MULTI_SEARCH_SELECT_DONE = msg`Done`;
export const SHARED_MULTI_SEARCH_SELECT_LOAD_MORE = msg`Load more`;
export const SHARED_MULTI_SEARCH_SELECT_NO_ITEMS = msg`No items match your search`;
